module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Meus Projetos'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importarProjeto
    }
  }, [_vm._v("Importar do SIEX")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "5px"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.duplicarProjeto
    }
  }, [_vm._v("Duplicar Ação")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mostrar apenas participações ativas"
    },
    on: {
      "change": _vm.controlaParticipacoesAtivas
    },
    model: {
      value: (_vm.participacoesAtivas),
      callback: function($$v) {
        _vm.participacoesAtivas = $$v
      },
      expression: "participacoesAtivas"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaMeusProjetos,
      "search": _vm.search,
      "no-data-text": 'Você não participa de nenhum projeto',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.nomeUnidade",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.unidade.format(props.item.nomeUnidade, props.item.siglaUnidade)))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "item.dataConclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataConclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaMeusProjetos.length) + " projetos\n          ")]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6f1cf92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/consulta-projetos/meus-projetos.vue
// module id = 412
// module chunks = 0